<!--
* UIID: UI-DLB-CT-120
* UI Name: Add Code Group
* Modify Date: 2020/08/06
-->
<template>
  <dialog-drag
    :id="id"
    :ref='"dialog-" + id'
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title
        class="headline white--text"
        primary-title
      >{{options.item.action == 'add' ? $t('lbl.codetable.addCodeDialog.pageHeaderAdd') : $t('lbl.codetable.addCodeDialog.pageHeaderModify')}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-row class="ma-0 data-section">
      <v-col cols="12" lg="4" class="pa-0">
        <v-row no-gutters style="height: 100%;">
          <v-col cols="12" lg="10" class="code-table-grid">
            <v-row no-gutters class="mb-2">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="code-group-label">{{$t('lbl.codetable.addCodeDialog.codeGroupName')}}</span>
            </v-row>
            <v-row no-gutters class="mb-2">
              <v-text-field
                ref="codeGrName"
                v-model="codeGroupName"
                class="data-table-filter-text-field custom-selectbox find-table-code"
                height="40"
                hide-details
                dense
                solo
                outlined
              ></v-text-field>
            </v-row>
            <v-row no-gutters class="mb-2">
              <div class="vuebar-element">
                <v-list nav dense class="code-group-list" :flat="true">
                  <v-list-item-group v-model="item" color="primary">
                    <v-list-item
                      v-for="(item, i) in codeGroupData"
                      :key="i"
                      @click="showCodeData(item)"
                    >
                      <v-list-item-icon>
                        <v-icon x-small>fas fa-circle</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <a class="group-code-link">{{item.CODE_GRP_CD}}</a>
                      </v-list-item-content>
                      <v-list-item-icon @click.stop="confirmDeleteItem(item)">
                        <v-icon x-small>fas fa-times</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
            </v-row>
          </v-col>
          <v-col cols="12" lg="2" class="pt-0 pb-0 btn-add-code-row">
            <v-btn
              class="btn btn-top btn-search btn-add-code"
              color="primary"
              @click="addCodeGroup"
              :disabled="isBtnActive"
            >
              <v-icon :size="20" class="mr-2">fas fa-angle-double-left</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="8" class="code-table-grid">
        <v-row class="ma-0">
          <!-- [S]  second table-->
          <v-col cols="5" class="pa-0 pr-3">
            <v-row class="ma-0">
              <v-col class="pa-0">
                <v-text-field
                  v-model="searchCodeName"
                  :placeholder="$t('lbl.common.conditionSearch.findbyCodeName')"
                  class="data-table-filter-text-field custom-selectbox find-table-code"
                  heigth="30"
                  outlined
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12" class="pa-0 pt-2">
                <v-data-table
                  :search="searchCodeName"
                  :headers="headerList.headerCodeName"
                  :items="codeGroupList"
                  :items-per-page="-1"
                  :hide-default-footer="true"
                  :disable-sort="false"
                  class="map-list-table code-list-data-table pb-0"
                  fixed-header
                >
                  <template v-slot:header.checkbox>
                    <v-checkbox
                      v-model="checkedAll"
                      @change="selectAllChange"
                      class="select-checkbox-layout-table align-center justify-center"
                      color="#dbd7db"
                      dense
                      hide-details
                    ></v-checkbox>
                  </template>
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr
                        v-for="(item,index) in items"
                        @click="onClickCodeDataPool(item)"
                        :key="item.ROWID"
                        :class="[((selectedRowLinked == item.CODE_GRP_CD) ||(selectedRowLinked == '' && index == 0)) ? 'selected_row' : '']"
                      >
                        <td class="checkbox-col">
                          <v-checkbox
                            v-model="item.checked"
                            @click.native.stop
                            @click.native="selectItemChange($event, item)"
                            class="select-checkbox-layout-table align-center justify-center"
                            color="#dbd7db"
                            dense
                            hide-details
                          ></v-checkbox>
                        </td>
                        <td class="code-grp-col no-wrap">{{ item.CODE_GRP_CD }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
          <!-- [E]  second table-->

          <!-- [S]  third table-->
          <v-col cols="7" class="pa-0">
            <v-row class="ma-0">
              <div class="pl-0 pt-0 pb-0 d-inline-flex mr-3" style="width: 200px">
                <v-text-field
                  v-model="codeDataPoolItems.data[0].SRC_CD"
                  @keyup.enter="queryCodeDataPool(selectedRowLinked)"
                  class="data-table-filter-text-field custom-selectbox find-table-code"
                  :placeholder="$t('lbl.common.conditionSearch.findbySourceCode')"
                  outlined
                  hide-details
                  dense
                  solo
                  heigth="30"
                ></v-text-field>
              </div>
              <div class="pl-0 pt-0 pb-0 d-inline-flex">
                <v-text-field
                  v-model="codeDataPoolItems.data[0].TRG_CD"
                  @keyup.enter="queryCodeDataPool(selectedRowLinked)"
                  class="data-table-filter-text-field custom-selectbox find-table-code"
                  :placeholder="$t('lbl.common.conditionSearch.findbyTargetCode')"
                  outlined
                  hide-details
                  dense
                  solo
                  heigth="30"
                ></v-text-field>
              </div>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12" class="pa-0 pt-2">
                <v-data-table
                  :headers="headerList.headerSourceTarget"
                  :items="dataPoolList"
                  :items-per-page="-1"
                  :hide-default-footer="true"
                  :disable-sort="false"
                  class="map-list-table code-list-data-table pb-0"
                  fixed-header
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr
                        tr
                        v-for="(item, index) in items"
                        @click="onClickCodeSourceTarget(item)"
                        :key="index"
                        :class="[ selectedRowPool == item.CODE_ITM_NO ? 'selected_row' : '']"
                      >
                        <td class="text-center no-wrap">{{ (searchSource != '' || searchTarget != '') ? index + 1 : (page - 1) * itemsPerPage + index + 1 }}</td>
                        <td class="code-grp-col no-wrap">{{ item.CODE_ITM_SRC_CD }}</td>
                        <td class="code-grp-col no-wrap">{{ item.CODE_ITM_TRG_CD }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
                <div class="d-inline-flex pa-0">
                  <v-select
                    v-model="itemsPerPage"
                    :items="rowPerPage"
                    @change="queryCodeDataPool(selectedRowLinked)"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox pt-2"
                    hide-details
                    dense
                    solo
                  ></v-select>
                  <v-select
                    v-model="page"
                    :items="listPage"
                    @change="queryCodeDataPool(selectedRowLinked, false)"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox pl-2 pt-2"
                    hide-details
                    dense
                    solo
                  ></v-select>
                  <div id="page-count-custom" class="flat-table-pagination pl-2">
                    <v-pagination
                      v-model="page"
                      :length="pageCount"
                      @input="queryCodeDataPool(selectedRowLinked, false)">
                    </v-pagination>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <!-- [E]  third table-->
        </v-row>
      </v-col>
    </v-row>
    <v-row class="no-gutters btn-code-section">
      <v-col cols="12" lg="4" class="pa-0 text-right">
        <v-row no-gutters>
          <v-col cols="12" lg="10">
            <v-btn class="btn btn-popup-search" color="primary" @click="saveCodeGroupName">
              {{$t('btn.common.save')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="8" class="pa-0 text-right">
        <v-btn class="btn btn-delete" @click="removeDialog">
          {{$t('btn.common.close')}}
        </v-btn>
      </v-col>
    </v-row>
    <dialogWindow
      ref="validateAddCode"
      :detail="$t('msg.codetable.clickBtnSave')"
      :showCancel="false"
      size="max"
      title="warning"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      :detail="$t('msg.common.deleteConfirm')"
      :dataValue="deleteData"
      :showCancel="true"
      @select-ok="deleteCodeGroup($event)"
      color="information"
      size="max"
      title="confirmDialog"
    ></dialogWindow>
    <dialogWindow
      ref="warningExistCode"
      :detail="warningExistCode"
      :showCancel="false"
      color="validation"
      size="max"
      title="warning"
    ></dialogWindow>
    <dialogWindow
      ref="warningSaveCodeGroup"
      :detail="$t('msg.common.require',['Code Group Name'])"
      :showCancel="false"
      size="max"
      title="warning"
      color="validation"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import { mapState } from "vuex";
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
import $ from "jquery";
import IconSvg from "@/vue-caas/components/IconBase.vue";

// import {
//   showSuccessMessage,
//   showErrorMessage,
//   showProgress,
//   hideProgress,
//   alertSuccess,
//   closeAlert
// } from "@/vue-dlb/utils/sys-util.js";

export default {
  name: "add-code-group-dialog",
  // props: [
  //   "id",
  //   "title",
  //   "options",
  //   "eventCb",
  //   "selectFile",
  //   "closeDialog",
  //   "dragStart",
  //   "dragEnd"
  // ],
  props:{
      id: String,
      title: String,
      options: Object,
      eventCb: Function,
      closeDialog: Function,
      dragStart: Function,
      dragEnd: Function,
      selectFile: String,
    },
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg
  },
  computed: {
    ...mapState("codetable", {
      codetables: "codetables",
      codeLinkedGroup: "codeLinkedGroup",
      codeDataPool: "codeDataPool",
      codeGroupList: "codeGroupList"
    }),
    isBtnActive(){
      if(this.selectMasterRows.length>0){
        return false;
      }else return true;
    },
  },
  data() {
    return {
      page: 1,
      pageCount: 1,
      itemsPerPage: 100,
      rowPerPage: [
        {value: 100, text: 'Show 100'},
        {value: 200, text: 'Show 200'},
        {value: 500, text: 'Show 500'},
      ],
      listPage: [
        {value: 1, text: 'Page 1'}
      ],
      storeDataPool: [],
      checkedAll:false,
      item: 0,
      slectedCtg: "",
      selectedRowLinked: "",
      selectedRowPool: "",
      selectedRowGroup: "",
      selectedCodeList:"",
      dataPoolList: [],
      searchCodeName: "",
      searchSource: "",
      searchTarget: "",
      selectMasterRows: [],
      codeGroupData: [],
      codeGroupDataFilter: [],
      codeGroupSearch: '',
      insertItem:[],
      deleteData:'',
      codeGroupName: '',
      warningExistCode:'',
      customerID:'',
      // searchItems: {
      //   src: {
      //     type: "",
      //     search: ""
      //   },
      //   target: {
      //     type: "",
      //     search: ""
      //   }
      // },
      codeListGroupItems: {
        header: ["CUST_ID", "OWNR_CUST_ID", "CTG_ID"],
        data: [
          {
            CUST_ID: "",
            OWNR_CUST_ID: "",
            CTG_ID: ""
          }
        ]
      },
      codeLinkedGroupItems: {
        header: ['CTG_ID'],
        data: [{
          CTG_ID: '',
        }],
      },
      codeDataPoolItems: {
        header: ["CUST_ID", "OWNR_CUST_ID", "GRP_CD", 'SRC_CD', 'TRG_CD', 'R_FROM', 'R_TO', 'SORT'],
        data: [{
          CUST_ID: "",
          OWNR_CUST_ID: "",
          GRP_CD: "",
          SRC_CD: '',
          TRG_CD: '',
          R_FROM: 1,
          R_TO: this.itemsPerPage,
          SORT: 'DEFAULT',
        }]
      },
      addDataItems:[
       {
          header: ['CTG_ID','CUST_ID','OWNR_CUST_ID','CTG_NM'],
          data: [],
        },
        {
          header: ['CTG_ID','STATUS','GRP_CD'],
          data: [],
        }
      ],
      modifyDataItems: {
        header: ["STATUS", "CTG_ID",'GRP_CD'],
        data: [],
      },
      modifyDataNameItems: {
        header: ["CTG_ID",'CTG_NM'],
        data: [
          {
            CTG_ID: '',
            CTG_NM: ''
          }
        ],
      },
      deleteDataItems: {
        header: ["STATUS", "CTG_ID",'GRP_CD'],
        data: [
          {
            STATUS: '',
            CTG_ID: '',
            GRP_CD: '',
          }
        ],
      },
      headerList: {
        headerCodeGroup: [
          {
            text: this.$t("tbl.mapBuilder.selectCodeTable.select"),
            value: "",
            width: "90px",
          },
          {
            text: this.$t("tbl.mapBuilder.selectCodeTable.codeGroup"),
            value: "CODE_CTG_NAME"
          }
        ],
        headerCodeName: [
          { value: "checkbox", text: "", width: "60px",class:"checkbox-col"},
          {
            text: this.$t("tbl.mapBuilder.selectCodeTable.groupCode"),
            value: "CODE_GRP_CD",
            width: "250px",
            align: "center"
          }
        ],
        headerSourceTarget: [
          { text: "No.", value: "ROWID", width: "75px" },
          {
            text: this.$t("tbl.mapBuilder.selectCodeTable.sourceCode"),
            value: "CODE_ITM_SRC_CD",
            align: "center"
          },
          {
            text: this.$t("tbl.mapBuilder.selectCodeTable.targetCode"),
            value: "CODE_ITM_TRG_CD",
            align: "center"
          }
        ]
      },
    };
  },

  created() {
    this.selectedRowGroup = this.options.item.codeCtg;
    this.slectedCtg = this.options.item.codeCtg;
    this.customerID = this.options.item.selectedRow.MST_CUST_ID;
    this.setFocus();
    this.queryCodeListGroup();
    if(this.options.item.action =='modify'){
      this.queryCodeLinkedGroup(this.options.item.selectedRow.CODE_CTG_ID);
      this.codeGroupName = this.options.item.selectedRow.CODE_CTG_NAME;
    }
  },

  watch:{
    // 2021.4.28 203728 SPKA-80 Issue 42 Add paging for Code Data Pool
    pageCount(newVal, oldVal) {
      if(newVal != oldVal){
        this.listPage = [];
        for(let i = 1; i <= newVal; i++){
          this.listPage.push({value: i, text: 'Page ' + i});
        }
      }
    },
  },

  methods: {
    queryCodeListGroup() {
      if(this.options.item.action === 'modify') {
        this.codeListGroupItems.data[0].CUST_ID = this.customerID;
      } else if(this.options.item.action === 'add') {
        this.codeListGroupItems.data[0].CUST_ID = this.$cookies.get("comp-id");
      }
      this.codeListGroupItems.data[0].OWNR_CUST_ID = this.$cookies.get("ownr-id");
      this.codeListGroupItems.data[0].CTG_ID = '';

      Store.dispatch("codetable/codeGroupList", this.codeListGroupItems).then(() => {
        if(this.codeGroupList.length > 0){
          this.selectedRowLinked = this.codeGroupList[0].CODE_GRP_CD;
          this.queryCodeDataPool(this.codeGroupList[0].CODE_GRP_CD)
        }else{
          this.dataPoolList = this.codeLinkedGroup;
          this.selectedRowLinked = this.codeLinkedGroup[0].CODE_GRP_CD;
          this.queryCodeDataPool(this.codeLinkedGroup[0].CODE_GRP_CD)
        }
      });
    },
    queryCodeDataPool(item, resetPage = true) {
      if(resetPage) this.page = 1;
      this.codeDataPoolItems.data[0].CUST_ID = this.$cookies.get("comp-id");
      this.codeDataPoolItems.data[0].OWNR_CUST_ID = this.$cookies.get("ownr-id");
      this.codeDataPoolItems.data[0].GRP_CD = item;
      // 2021.4.28 203728 SPKA-80 Issue 42 Add paging for Code Data Pool
      this.codeDataPoolItems.data[0].R_FROM = this.itemsPerPage * (this.page - 1) + 1;
      this.codeDataPoolItems.data[0].R_TO = this.itemsPerPage * this.page;
      Store.dispatch("codetable/codeDataPoolPaging", this.codeDataPoolItems).then((res) => {
        this.dataPoolList = res.codeDataPool;
        this.pageCount = Math.floor(res.totalDataPool / this.itemsPerPage) + 1;
        if(res.codeDataPool.length > 0){
          this.selectedRowPool = res.codeDataPool[0].CODE_ITM_NO;
          this.storeDataPool = this.dataPoolList;
        }
      });
    },
    queryCodeLinkedGroup(item){
      this.codeLinkedGroupItems.data[0].CTG_ID = item;
      Store.dispatch("codetable/codeLinkedGroup", this.codeLinkedGroupItems).then(() => {
        this.codeGroupData = this.codeLinkedGroup;
      });
    },
    onClickCodeGroup(item) {
      this.selectedRowGroup = item.CODE_CTG_ID;
      if (item.CODE_CTG_ID != undefined && item.CODE_CTG_ID != null)
        this.queryCodeLinkedGroup(item.CODE_CTG_ID);
    },
    onClickCodeDataPool(item) {
      this.selectedRowLinked = item.CODE_GRP_CD;
      if (item.CODE_GRP_CD != undefined && item.CODE_GRP_CD != null)
        this.queryCodeDataPool(item.CODE_GRP_CD);
    },
    onClickCodeSourceTarget(item) {
      this.selectedRowPool = item.CODE_ITM_NO;
    },
    // onFilterSourceTarget(item) {
    //   this.searchItems.src.type = "CODE_ITM_SRC_CD";
    //   this.searchItems.src.search = this.searchSource;
    //   this.searchItems.target.type = "CODE_ITM_TRG_CD";
    //   this.searchItems.target.search = this.searchTarget;
    //   this.searchItems.source = this.storeDataPool;
    //   Store.commit("codetable/SET_CODE_FILTER", this.searchItems);
    //   this.dataPoolList = this.codeDataPool;
    // },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    refreshDialog(dialog){
      dialog.id = this.id;
      this.$emit("refreshData",this.options.item.selectedRow)
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    selectItemChange(event, item) {
      this.onClickCodeDataPool(item);
      let checked = item.checked;
      if (checked == true) {
        this.selectMasterRows.push(item);
      } else if (checked == false) {
        let index = this.findIndexItem(item, this.selectMasterRows, "ROWID");
        if (index != null) {
          this.selectMasterRows.splice(index, 1);
        }
      }
    },
    selectAllChange(value) {
      let selectAllItems = [];
      if (value) {
        for (let i = 0; i < this.codeGroupList.length; i++) {
          let item = this.codeGroupList[i];
          item.checked = value;
          this.checkedAll = value;
          selectAllItems.push(item);
        }
        this.selectMasterRows = selectAllItems;
      } else {
        let selectAllItems = [];
        for (let i = 0; i < this.codeGroupList.length; i++) {
          let item = this.codeGroupList[i];
          item.checked = value;
          this.checkedAll = value;
          selectAllItems.push(item);
        }
        this.selectMasterRows = [];
      }
    },
    findIndexItem(item, arr, col) {
      let prop = typeof col == "undefined" ? "id" : col;
      let index = arr.findIndex(row => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },
    addCodeGroup() {
      if(this.codeGroupData.length < 1) {
        for(let i=0;i<this.selectMasterRows.length;i++) {
          this.insertItem.push(this.selectMasterRows[i]);
          this.codeGroupData.push(this.selectMasterRows[i]);
        }
      } else {
        // List contain different codeName
        let results = this.selectMasterRows.filter(({ CODE_GRP_CD: value1 }) => !this.codeGroupData.some(({ CODE_GRP_CD: value2 }) => value2 === value1));
        let generalResults = this.selectMasterRows.filter(({ CODE_GRP_CD: value1 }) => this.codeGroupData.some(({ CODE_GRP_CD: value2 }) => value2 === value1));
        if(generalResults.length == 1){
          this.warningExistCode = this.$t('msg.codetable.warningExistCode');
          this.$refs.warningExistCode.dialog = true;
          return ;
        }else if(generalResults.length > 1){
          this.warningExistCode = this.$t('msg.codetable.warningExistCodes');
          this.$refs.warningExistCode.dialog = true;
          return ;
        }
        // this.insertItem = results;
        results.forEach(element => this.insertItem.push(element));  
        this.codeGroupData = this.codeGroupData.concat(results);
      }
      this.queryCodeListGroup();
      this.checkedAll = false;
      this.selectMasterRows=[];
    },
    onFilterGroupCode(){
      let filterData = [];
      let datarows = this.codeGroupDataFilter;
      if(this.codeGroupSearch ==''){
        filterData= datarows;
      }else{
        let searchData= this.codeGroupSearch;
        filterData = datarows.filter( item => item.CODE_GRP_CD.toLowerCase().includes(searchData.toLowerCase()))
      }
      this.codeGroupData = filterData;
    },
    confirmDeleteItem (item) {
      this.deleteData = item;
      this.$refs.confirmDeleteFileDialog.dialog = true;
    },
    deleteCodeGroup(item){
      this.modifyDataItems.data.push(
          {
            STATUS: 'D',
            CTG_ID: this.options.item.selectedRow.CODE_CTG_ID,
            GRP_CD: item.CODE_GRP_CD
          }
      );
      const tempArr = this.codeGroupData.filter(element =>  element.CODE_GRP_CD != item.CODE_GRP_CD);
      this.codeGroupData = tempArr;
    },
    saveCodeGroupName(){
      if (this.codeGroupData.length < 1) {
        this.$refs.validateAddCode.dialog = true;
        return;
      } else if (this.codeGroupName.trim() == '') {
          this.$refs.warningSaveCodeGroup.dialog = true;
      } else if (this.options.item.action =="add") {
         for(var i = 0; i <this.codeGroupData.length; i++){
          this.addDataItems[0].data[i] = {
            CTG_ID: '',
            CUST_ID: this.$cookies.get('comp-id'),
            OWNR_CUST_ID : this.$cookies.get('ownr-id'),
            CTG_NM: this.codeGroupName,
          };
          this.addDataItems[1].data[i] = {
            CTG_ID: '',
            STATUS: 'I',
            GRP_CD: this.codeGroupData[i].CODE_GRP_CD,
          };
        }
        Store.dispatch("codetable/addCategory", this.addDataItems).then(() => {
            this.refreshDialog({});
        });
      } else {
        if(this.insertItem.length > 0) {
          for(var i = 0; i < this.insertItem.length; i++){
            this.modifyDataItems.data.push({
              STATUS: 'I',
              CTG_ID: this.options.item.selectedRow.CODE_CTG_ID,
              GRP_CD: this.insertItem[i].CODE_GRP_CD,
            });
          }
        }
        if (this.codeGroupName.trim() != this.options.item.selectedRow.CODE_CTG_NAME.trim()) {
          this.modifyDataNameItems.data[0].CTG_ID = this.options.item.selectedRow.CODE_CTG_ID;
          this.modifyDataNameItems.data[0].CTG_NM = this.codeGroupName;
          Store.dispatch("codetable/modifyCategoryName", this.modifyDataNameItems).then(() => {
            this.refreshDialog({});
          });
        }
        if(this.modifyDataItems.data.length > 0) {
          Store.dispatch("codetable/modifyCategoryDetail", this.modifyDataItems).then(() => {
            this.refreshDialog({});
          });
        }
      }
    },
    showCodeData(item) {
      this.selectedRowLinked = item.CODE_GRP_CD;
      if (item.CODE_GRP_CD != undefined && item.CODE_GRP_CD != null)
        this.queryCodeDataPool(item.CODE_GRP_CD);    
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.codeGrName.focus();
      }, 300);
    }
  }
};
</script>
<style lang="scss">
.add-code-dialog .data-section {
  height: 600px;
}
.btn-code-section{
  height: 30px;
  margin-top:10px;
}
.code-table-grid {
  box-sizing: border-box;
  border-radius: 3px;
  padding: 20px 15px 15px 15px !important;
}
.btn-add-code-row {
  text-align: center !important;
  margin: auto !important;
  display: inline-block;
  padding:0 10px !important;
}
.btn-add-code-row .v-btn.v-btn--contained.btn-add-code{
  padding: 0;
  min-width: 100%;
}
.map-list-table.code-list-data-table .v-data-table__wrapper {
  overflow-y: auto;
  max-height: 485px;
  min-height: 485px;
  overflow-x: hidden;
}
.maplist-layout-dialog .v-data-table.code-list-data-table thead tr:last-child {
  th {
    height: 25px !important;
    i.mdi.mdi-arrow-up {
    font-size: 14px !important;
    }
  }
  th.checkbox-col {
    i.mdi.mdi-arrow-up  {
    display: none;
    }
  }
  th.sortable:hover,th.sortable.active {
    color: #000000;
  }
}
.maplist-layout-dialog .v-data-table.code-list-data-table {
  .v-icon.v-icon--dense  {
    font-size: 14px;
  }
}
.group-code-link{
  text-decoration: underline;
  font-size: 13px;
  font-weight: bold
}
.code-group-list.v-list .fas.fa-times {
  color: #CD5F5F;
}
.code-group-list.v-list .fas.fa-circle{
  font-size:8px !important;
}
.code-group-list.v-list .v-list-item__icon:first-child {
    margin-right: 8px;
}
.code-group-list.v-list .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 24px;
}
.code-group-label{
  font-size: 16px;
  font-weight:bold;
}
.vuebar-element {
    max-height: 345px;
    overflow-y: auto;
    width: 100%
}
.vuebar-element::-webkit-scrollbar {
      width: 8px;
}
.vuebar-element::-webkit-scrollbar-thumb{
  border-radius: 10px;
}
.theme--dark {
  .code-group-label{
    color:#C6CACC
  }
  .code-list-data-table.v-data-table tbody tr.selected_row {
    background: #243645 !important;
  }
  .vuebar-element .v-list{
   background: #232329;
  }
  .vuebar-element::-webkit-scrollbar-track  {
    background-color: #595B64;
  }
  .vuebar-element::-webkit-scrollbar-thumb {
    background-color: #DEDFE0;
  }
  .vuebar-element::-webkit-scrollbar-corner{
    background-color: #595B64;
  }
  // .code-list-data-table .v-data-table__wrapper {
  //   background: transparent;
  // }
  .code-table-grid {
    background-color: #232329;
    border: 1px solid #5f616d;
  }
  .code-group-list.v-list .v-list-item--active {
    cursor: default;
    color: white;
    background:#243645 !important;
  }
}
.theme--light{
  .code-list-data-table.v-data-table tbody tr.selected_row {
    background: #eaf1f8  !important;
  }
  .vuebar-element{
    background: #FFFFFF;
  }
  .vuebar-element .v-item--active {
      background: #eaf1f8  !important;
  }
  .vuebar-element::-webkit-scrollbar-track  {
    background-color: #FFFFFF;
  }
  .vuebar-element::-webkit-scrollbar-corner  {
    background-color: #FFFFFF;
  }
  .vuebar-element::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
  }
  // .code-list-data-table .v-data-table__wrapper {
  //   background: #FFFFFF;
  // }
  .code-table-grid {
    background-color: #FAFCFF;
    border: 1px solid #F0F7FB;
  }
}
/* .theme--dark.v-data-table.v-data-table--fixed-header.code-list-data-table thead tr:last-child th{
  border-bottom: none !important;
} */
</style>